import { render, staticRenderFns } from "./AppCollectionItems.vue?vue&type=template&id=61a769ec&scoped=true&"
import script from "./AppCollectionItems.vue?vue&type=script&lang=ts&"
export * from "./AppCollectionItems.vue?vue&type=script&lang=ts&"
import style0 from "./AppCollectionItems.vue?vue&type=style&index=0&id=61a769ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a769ec",
  null
  
)

export default component.exports